import React, { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { closeAllModals, closeModal } from '../../store/modal/modal'
import { selectDocument } from '../../store/processDocument/document'
import { UpdateExternalDocumentContactModal } from '../UpdateExternalContact/UpdateExternalContact'
import { DocumentSummaryIntegrationExportModal } from './DocumentSummaryIntegrationExportModal/DocumentSummaryIntegrationExportModal'
import { DocumentSummaryDocumentConnectorExportModal } from './DocumentSummaryDocumentConnectorExportModal/DocumentSummaryDocumentConnectorExportModal'

export const DocumentModalManager: React.FC = () => {
  const dispatch = useAppDispatch()
  const modals = useAppSelector((state) => state.modal.modals)
  const document = useAppSelector(selectDocument)

  useEffect(() => {
    return () => {
      dispatch(closeAllModals())
    }
  }, [dispatch])

  return (
    <>
      {modals.map((modal) => {
        const { id, type, serviceId, user } = modal

        if (!type || !serviceId) {
          return null
        }

        switch (type) {
          case 'exportDocumentSummary':
            return <DocumentSummaryIntegrationExportModal key={id} show={true} serviceId={serviceId} onHide={() => dispatch(closeModal(id))} />

          case 'saveDocumentSummaryToDocumentConnector':
            return <DocumentSummaryDocumentConnectorExportModal key={id} serviceId={serviceId} onHide={() => dispatch(closeModal(id))} />

          case 'updateDocumentContact':
            if (!user || !document) {
              return null
            }

            return (
              <UpdateExternalDocumentContactModal
                key={id}
                show={true}
                user={user}
                serviceId={serviceId}
                documentId={document.id}
                files={document.files}
                onClose={() => dispatch(closeModal(id))}
              />
            )

          default:
            return null
        }
      })}
    </>
  )
}
